import React, { useState } from "react";
import { Link, Redirect, useHistory, useParams } from "react-router-dom";
import { setNewPasswordAsync } from "../redux/authApi";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { PASSWORD_REGEX } from "../../../utils/constants";

function SetNewPassword() {
  const dispatch = useDispatch();
  const history = useHistory();

  const [passwordShown, setPasswordShown] = useState(false);
  //password visibality
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const [passwordShown_v2, setPasswordShown_v2] = useState(false);
  //password visibality
  const togglePasswordVisiblity_v2 = () => {
    setPasswordShown_v2(passwordShown_v2 ? false : true);
  };
  //formik validation schema
  const PasswordSchema = () =>
    Yup.object().shape({
      password: Yup.string()
        .required("Password is required.")
        .trim()
        .matches(
          PASSWORD_REGEX,
          "Password should contain min 6 and max 32 characters with atleast one Alphanumeric and special character."
        ),
      confirmPassword: Yup.string()
        .required("Confirm password is required.")
        .trim()
        .test("passwords-match", "Passwords must match", function(value) {
          return this.parent.password === value;
        }),
    });

  const params = useParams();
  //redirect to login page
  const redirectBack = () => {
    history.push("/auth/login");
  };

  const onSetPassword = (values, resetForm) => {
    resetForm();
    //call set new password api
    dispatch(
      setNewPasswordAsync(
        {
          resetToken: params.resetToken,
          password: values.password,
        },
        redirectBack
      )
    );
  };

  const { user } = useSelector((state) => state.auth, shallowEqual);
  //redirect to dashboard page
  if (!params.resetToken) {
    return <Redirect to="/" />;
  }

  return (
    <>
      <Formik
        initialValues={{
          password: user && user.password ? user.password : "",
          confirmPassword: "",
        }}
        validationSchema={PasswordSchema}
        onSubmit={(values, { resetForm }) => {
          onSetPassword(values, resetForm);
        }}
      >
        {({ handleSubmit }) => (
          <>
            <div className="login-form login-signin" id="kt_login_signin_form">
              <div className="text-center mb-10 mb-lg-15">
                <h3 className="font-size-h1">Set New Password</h3>
                <p className="text-muted font-weight-bold">
                  Please never share with anyone for safe use.
                </p>
              </div>

              <Form className="form text-left" onSubmit={handleSubmit}>
                <div className="form-group fv-plugins-icon-container">
                  <div className="frpsswrd">
                    <Field
                      placeholder="New Password"
                      type={passwordShown ? "text" : "password"}
                      className={`form-control  border-less-input`}
                      name="password"
                    />
                    <i
                      onClick={togglePasswordVisiblity}
                      className="far fa-eye-slash"
                    ></i>
                  </div>
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="text-danger"
                  />
                </div>
                <div className="form-group fv-plugins-icon-container">
                  <div className="frpsswrd">
                    <Field
                      placeholder="Confirm Password"
                      type={passwordShown_v2 ? "text" : "password"}
                      className={`form-control  border-less-input`}
                      name="confirmPassword"
                    />
                    <i
                      onClick={togglePasswordVisiblity_v2}
                      className="far fa-eye-slash"
                    ></i>
                  </div>
                  <ErrorMessage
                    name="confirmPassword"
                    component="div"
                    className="text-danger"
                  />
                </div>
                <div className="form-group mb-0 mt-0">
                  <div className="row">
                    <div className="col-md-12 text-center mb-0">
                      <button
                        id="kt_login_signin_submit"
                        type="submit"
                        className="btn btn-blue"
                      >
                        <span>Submit</span>
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
              <div className="text-center mt-15" style={{ color: "white" }}>
                <p className="opacity60 fn_s_14 f-w-400">
                  If you don't want to set new password
                </p>
                <Link
                  to="/auth"
                  className="fn_s_14 f-w-500 text-dark-50 text-hover-primary uppercase"
                  style={{ color: "white" }}
                >
                  Back to Login
                </Link>
              </div>
            </div>
          </>
        )}
      </Formik>
    </>
  );
}
export default SetNewPassword;
